import React, { useEffect, useState } from 'react';
import { Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const RejectionModal = ({ open, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) setReason('');
  }, [open]);

  const handleConfirm = async () => {
    const trimmedReason = reason.trim();
    if (!trimmedReason || submitting) return;

    setSubmitting(true);
    try {
      const succeeded = await onConfirm(trimmedReason);
      if (succeeded !== false) setReason('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={t('leave.rejectRequest')}
      open={open}
      onOk={handleConfirm}
      onCancel={submitting ? undefined : onCancel}
      okText={t('leave.rejectBtn')}
      cancelText={t('common.cancel')}
      confirmLoading={submitting}
      okButtonProps={{
        danger: true,
        disabled: !reason.trim() || submitting,
        'data-testid': 'reject-confirm',
      }}
    >
      <Input.TextArea
        rows={4}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
        placeholder={t('leave.rejectReasonPlaceholder')}
        data-testid="reject-reason-input"
      />
    </Modal>
  );
};

export default RejectionModal;
